import {hexToRgbTo} from "../nodevn/ultil";

export default function textConfig( values: any, bgColor: any){
	let { text, textColor, fontFamily, fontSize, lineHeight, fontWeight, letterSpacing } = values || []
	lineHeight = lineHeight || fontSize;
	fontWeight = fontWeight || 400;
	letterSpacing = letterSpacing || 1;
	bgColor = bgColor || values?.bgColor;
	
	const style = { fontFamily, fontSize, fontWeight, lineHeight: `${lineHeight}px` }
	
	if(!textColor && bgColor){
		const $rgb = hexToRgbTo(bgColor);
		textColor = $rgb < 180 ? '#ffffff' : '#000000';
	}
	
	return [text, { bgColor, textColor, style, letterSpacing }]
}